import React, { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import logo from "../../assets/ZS_NEXATECH_LOGO_NEW_optimized.png";

const linkClass = ({ isActive }) =>
  `nav-link${isActive ? " is-active" : ""}`;

const navItems = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/about", label: "About" },
  { to: "/founder", label: "Founder" },
  { to: "/portfolio", label: "Portfolio" },
  { to: "/blog", label: "Blog" },
  { to: "/student-projects", label: "Student Projects" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [menuState, setMenuState] = useState({
    isOpen: false,
    openedAtPath: null,
  });
  const location = useLocation();
  const isMenuVisible =
    menuState.isOpen && menuState.openedAtPath === location.pathname;

  const toggleMenu = () => {
    setMenuState((currentValue) =>
      currentValue.isOpen && currentValue.openedAtPath === location.pathname
        ? { isOpen: false, openedAtPath: currentValue.openedAtPath }
        : { isOpen: true, openedAtPath: location.pathname }
    );
  };

  const closeMenu = () => {
    setMenuState((currentValue) => ({
      isOpen: false,
      openedAtPath: currentValue.openedAtPath,
    }));
  };

  useEffect(() => {
    if (!isMenuVisible) {
      document.body.style.overflow = "";
      return undefined;
    }

    const handlePointerDown = (event) => {
      if (
        event.target.closest(".nav-list") ||
        event.target.closest(".menu-toggle")
      ) {
        return;
      }

      closeMenu();
    };

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        closeMenu();
      }
    };

    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        closeMenu();
      }
    };

    document.body.style.overflow = "hidden";
    document.addEventListener("pointerdown", handlePointerDown);
    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("resize", handleResize);

    return () => {
      document.body.style.overflow = "";
      document.removeEventListener("pointerdown", handlePointerDown);
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("resize", handleResize);
    };
  }, [isMenuVisible]);

  return (
    <header className="site-header">
      <div className="site-shell row">
        <NavLink to="/" className="logo-container-3d">
          <img
            src={logo}
            alt="ZS NEXATECH Logo"
            loading="eager"
            className="logo-3d-zoom"
            draggable="false"
            style={{
              height: "clamp(72px, 12vw, 140px)",
              width: "auto",
              display: "block",
              objectFit: "contain",
              objectPosition: "center",
              border: "none",
              outline: "none",
              boxShadow: "none",
              background: "transparent",
              imageRendering: "high-quality",
              WebkitFontSmoothing: "antialiased",
              MozOsxFontSmoothing: "grayscale",
            }}
          />

          <div className="brand holo-text brand-float-animation">
            <span className="font-black" style={{ letterSpacing: "0.15em" }}>
              ZS NEXATECH
            </span>
            <span className="text-xs font-semibold tracking-widest">
              From Ideas To Impact
            </span>
          </div>
        </NavLink>

        <button
          className="menu-toggle"
          onClick={toggleMenu}
          aria-label={isMenuVisible ? "Close menu" : "Open menu"}
          aria-controls="mobile-navigation"
          aria-expanded={isMenuVisible}
          type="button"
        >
          <span className={`hamburger-line ${isMenuVisible ? "open" : ""}`}></span>
          <span className={`hamburger-line ${isMenuVisible ? "open" : ""}`}></span>
          <span className={`hamburger-line ${isMenuVisible ? "open" : ""}`}></span>
        </button>
      </div>

      <nav
        id="mobile-navigation"
        className={`nav-list ${isMenuVisible ? "open" : ""}`}
        aria-label="Navigation"
      >
        <button
          type="button"
          className="nav-close"
          onClick={closeMenu}
          aria-label="Close navigation menu"
        >
          Close
        </button>

        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={linkClass}
            onClick={closeMenu}
          >
            {item.label}
          </NavLink>
        ))}
      </nav>
    </header>
  );
}
